import { useSelector } from "react-redux";
import { LayoutAdminCafe, LayoutUserCafe } from "../../../layout/layout_cafe";
import HistoryPage from "../../../pages/users/ordered/components/historyPage";
import { State } from "../../../reducer";

export function OrderedCafe() {
  const user = useSelector((state: State) => state.user)
  return (
    <>
      {user?.role === "admin" ? (
        <LayoutAdminCafe>
          <HistoryPage />
        </LayoutAdminCafe>
      ) : (
        <LayoutUserCafe>
          <HistoryPage />
        </LayoutUserCafe>
      )}
    </>
  );
}

export function OrderedBar() {
  const user = useSelector((state: State) => state.user)
  return (
    <>
      {user?.role === "admin" ? (
        <LayoutAdminCafe>
        <HistoryPage />
      </LayoutAdminCafe>
      ) : (
        <LayoutAdminCafe>
        <HistoryPage />
      </LayoutAdminCafe>
      )}
    </>
  );
}
